import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { StakeUpdateErrorModel } from '../../../../models';
import { IPlaceButtonState } from '../../../../state';
import { TotalStake } from '../../../stake/stake-utils';

export const PLACE_BUTTON_STATE_SERVICE = new InjectionToken<IPlaceButtonStateService>('PLACE_BUTTON_STATE_SERVICE');
export const PLACE_BUTTON_TITLE_SERVICE = new InjectionToken<IPlaceButtonTitleService>('PLACE_BUTTON_TITLE_SERVICE');
export const PLACE_BUTTON_MESSAGE_SERVICE = new InjectionToken<IPlaceButtonMessageService>('PLACE_BUTTON_MESSAGE_SERVICE');
export const PLACE_BUTTON_DISABLE_SERVICE = new InjectionToken<IPlaceButtonDisableService>('PLACE_BUTTON_DISABLE_SERVICE');
export const PLACE_BUTTON_ACTION_SERVICE = new InjectionToken<IPlaceButtonActionService>('PLACE_BUTTON_ACTION_SERVICE');
export const PLACE_BUTTON_ACTION_HANDLER_SERVICE = new InjectionToken<IPlaceButtonActionHandlerService>('PLACE_BUTTON_ACTION_HANDLER_SERVICE');
export const PLACE_BUTTON_VIEWMODEL_SERVICE = new InjectionToken<IPlaceButtonViewModelService>('PLACE_BUTTON_VIEWMODEL_SERVICE');

export interface IPlaceButtonStateService {
    get state$(): Observable<IPlaceButtonState>;
}

export interface IPlaceButtonTitleService {
    get buttonTitle$(): Observable<string>;
}

export interface IPlaceButtonMessageService {
    get buttonMessage$(): Observable<string>;
}

export interface IPlaceButtonDisableService {
    get isButtonDisabled$(): Observable<boolean>;
}

export interface IPlaceButtonActionHandlerService {
    makeDepositHandler(stakes: TotalStake[]): PlaceButtonActionPredicate;
    getDepositAndBetHandler(): PlaceButtonActionPredicate;
    getDepositHandler(): PlaceButtonActionPredicate;
    getAcceptChangesHandler(): PlaceButtonActionPredicate;
    getLoginHandler(): PlaceButtonActionPredicate;
    getConfirmHandler(): PlaceButtonActionPredicate;
    makePlaceHandler(isFreeBet: boolean): PlaceButtonActionPredicate;
    makeAcceptAndPlaceBetHandler(isFreeBet: boolean): PlaceButtonActionPredicate;
    getUpdateMinStakeHandler(StakeUpdateErrorModels: StakeUpdateErrorModel[]): PlaceButtonActionPredicate;
}

export interface IPlaceButtonActionService {
    get action$(): Observable<PlaceButtonActionPredicate>;
}

export type PlaceButtonActionPredicate = () => boolean | void;

export interface IPlaceButtonViewModelService {
    get viewModel$(): Observable<IPlaceButtonViewModel>;
}

export interface IPlaceButtonViewModel {
    action: PlaceButtonActionPredicate;
    title: string;
    message: string;
    isDisabled: boolean;
    isProcessing: boolean;
    state: IPlaceButtonState;
    selectedPaymentType?: string;
}
